import useStore, { WizardQuestionsSelector } from '___store'
import { Option } from '___types'
import { Input, Select } from 'components/CasusComponents'
import React, { FunctionComponent, useMemo } from 'react'

type UseStoreHookResultType = {
  wizardQuestions: WizardQuestionsSelector
  optionById?: Option
  updateOption: (option: Partial<Option> & { optionId: string }) => void
}
export const PrefillConfig: FunctionComponent<{ id: string }> = React.memo(props => {
  const { id } = props

  const {
    wizardQuestions,
    optionById: option,
    updateOption,
  } = useStore('selectWizardQuestions', `selectOptionById[${id}]`, 'updateOption') as UseStoreHookResultType

  const [question, instance, value, concatString] = useMemo(() => {
    return (option?.prefill?.split(':').map(s => s || undefined) || []) as [string, string, string, string]
  }, [option])

  return (
    <div className="PrefillConfig-wrapper">
      <Select
        options={
          wizardQuestions?.reduce((result, question) => Object.assign(result, { [question.id]: question.text ?? 'No question text...' }), {}) || {}
        }
        value={question}
        onSelect={qid => updateOption({ optionId: id, prefill: [qid, instance, value, concatString].join(':') })}
      />
      <Select
        options={{ match: 'Match Instance', first: 'First Instance', last: 'Last Instance', all: 'All instances' }}
        value={instance}
        onSelect={inst => updateOption({ optionId: id, prefill: [question, inst, value, concatString].join(':') })}
      />
      <Select
        options={{ first: 'First Value', last: 'Last Value', all: 'All Values' }}
        value={value}
        onSelect={val => updateOption({ optionId: id, prefill: [question, instance, val, concatString].join(':') })}
      />
      <Input
        type="text"
        value={concatString ?? ''}
        onInput={event => updateOption({ optionId: id, prefill: [question, instance, value, (event.target as HTMLInputElement).value].join(':') })}
      />
    </div>
  )
})
PrefillConfig.displayName = 'PrefillConfig'

export default PrefillConfig
